// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    MoonStar,
    Mop,
    MopSparkles,
    Mosque,
    Motorbike,
    Mountain,
    MountainSnow,
    Mouse,
    MouseLeft,
    MouseOff,
    MousePointer,
    MousePointer2,
    MousePointer2Off,
    MousePointerBan,
    MousePointerClick,
    MouseRight,
    Move,
    Move3d,
    MoveDiagonal,
    MoveDiagonal2,
    MoveDown,
    MoveDownLeft,
    MoveDownRight,
    MoveHorizontal,
    MoveLeft,
    MoveRight,
    MoveUp,
    MoveUpLeft,
    MoveUpRight,
    MoveVertical,
    Music,
    Music2,
    Music3,
    Music4,
    Navigation,
    Navigation2,
    Navigation2Off,
    NavigationOff,
    Network,
    Newspaper,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "moon-star" through "newspaper", inclusive. */
const shard: Record<string, LucideIcon> = {
    "moon-star": MoonStar,
    mop: Mop,
    "mop-sparkles": MopSparkles,
    mosque: Mosque,
    motorbike: Motorbike,
    mountain: Mountain,
    "mountain-snow": MountainSnow,
    mouse: Mouse,
    "mouse-left": MouseLeft,
    "mouse-off": MouseOff,
    "mouse-pointer": MousePointer,
    "mouse-pointer-2": MousePointer2,
    "mouse-pointer-2-off": MousePointer2Off,
    "mouse-pointer-ban": MousePointerBan,
    "mouse-pointer-click": MousePointerClick,
    "mouse-right": MouseRight,
    move: Move,
    "move-3d": Move3d,
    "move-diagonal": MoveDiagonal,
    "move-diagonal-2": MoveDiagonal2,
    "move-down": MoveDown,
    "move-down-left": MoveDownLeft,
    "move-down-right": MoveDownRight,
    "move-horizontal": MoveHorizontal,
    "move-left": MoveLeft,
    "move-right": MoveRight,
    "move-up": MoveUp,
    "move-up-left": MoveUpLeft,
    "move-up-right": MoveUpRight,
    "move-vertical": MoveVertical,
    music: Music,
    "music-2": Music2,
    "music-3": Music3,
    "music-4": Music4,
    navigation: Navigation,
    "navigation-2": Navigation2,
    "navigation-2-off": Navigation2Off,
    "navigation-off": NavigationOff,
    network: Network,
    newspaper: Newspaper,
};

export default shard;
